import React, { useState } from 'react'
import { Card } from './ui'
import { SCRIPT_BOOK } from '../lib/scriptbook'

// Skrip telesales sekarang diambil dari Script Book (di-generate dari file Word)
const SCRIPTS = SCRIPT_BOOK

// ─── Data Playbook (dari ICS Compute Telesales Playbook 2026) ───────────────

const SOLUTIONS = [
  { icon: '☁️', name: 'Cloud Infrastructure', desc: 'Cloud Migration, Backup & DR, Managed Services, Hybrid Cloud, Landing Zone, SMB & CDN' },
  { icon: '📊', name: 'Data & Analytics', desc: 'Data Lakehouse, Real-time Pipeline, BI & Reporting, Data Governance, Predictive Analytics, FinOps' },
  { icon: '🔍', name: 'APM & Monitoring', desc: 'Application/Infra Monitoring, Log Management, Real User Monitoring, DevOps Visibility' },
  { icon: '🔒', name: 'Cybersecurity', desc: 'Endpoint Security, NGFW, Cloud Security, IAM, SIEM & SOAR, SOC, Pen Testing' },
  { icon: '🏢', name: 'ERP (Odoo)', desc: 'Finance, Inventory & Supply Chain, CRM, HR & Payroll, Manufacturing, E-Commerce' },
  { icon: '🦊', name: 'GitLab', desc: 'DevSecOps, CI/CD, Source Code Management, Security Scanning (SAST/DAST), Container Registry' },
]

const WORKFLOW = [
  { step: '01', act: 'Database Farming', out: 'LinkedIn, referral, riset manual. Min. 30–40 kontak valid/hari per agent, langsung dilog ke CRM.' },
  { step: '02', act: 'Outbound Calling', out: 'Hubungi database, probe pain point, kumpulkan sinyal BANT awal. Update CRM setiap selesai call.' },
  { step: '03', act: 'Kualifikasi Lead', out: 'Konfirmasi 70% BANT. Min 3 dari 4 kriteria = Opportunity. Siapkan brief prospek.' },
  { step: '04', act: 'Meeting & Handoff ke AM', out: 'Set meeting discovery/demo. Passing full context ke AM. AM yang negosiasi & close.' },
]


const KPI_TABLES = [
  {
    title: 'KPI Halimah — Telesales + Account Management',
    rows: [
      ['Harian', 'Outbound Calls (connected, 70% BANT)', 'Min. 15 calls/hari'],
      ['Harian', 'DB Farming (kontak valid)', '30 kontak/hari'],
      ['Harian', 'CRM Update', 'Semua call outcome ter-log'],
      ['Mingguan', 'Meetings Set', 'Min. 2 meetings/minggu'],
      ['Mingguan', 'Account Check-ins (existing)', '5 touchpoints/minggu'],
      ['Mingguan', 'New DB Added', '5 kontak baru/minggu'],
      ['Bulanan', 'New Accounts Opened', '3 akun/bulan'],
      ['Bulanan', 'Total DB Generated', '20 kontak/bulan'],
    ],
  },
  {
    title: 'KPI Yonila — High-Volume Calling Specialist',
    rows: [
      ['Harian', 'Outbound Calls (connected, 70% BANT)', 'Min. 20 calls/hari'],
      ['Harian', 'DB Farming (kontak valid)', '40 kontak/hari'],
      ['Harian', 'CRM Update', 'Semua call outcome ter-log'],
      ['Mingguan', 'Meetings Set', 'Min. 3 meetings/minggu'],
      ['Mingguan', 'Leads Qualified', '7–8 leads/minggu'],
      ['Mingguan', 'Call-to-Lead Rate', '≥10% conversion'],
      ['Bulanan', 'Total Leads Qualified', '30 leads/bulan'],
      ['Bulanan', 'Total DB Generated', '40 kontak/hari'],
    ],
  },
  {
    title: 'KPI Salsa & Yulisa — New Hires',
    rows: [
      ['Bulan 1–2', 'Outbound Calls', '20 calls/hari'],
      ['Bulan 1–2', 'DB Farming', '40 kontak/hari'],
      ['Bulan 1–2', 'Meetings Set', 'Min. 3/minggu'],
      ['Bulan 1–2', 'Shadowing Sessions', '4 sesi (total)'],
      ['Bulan 1–2', 'Product Assessment', 'Lulus 2 assessment'],
      ['Bulan 3+', 'Outbound Calls', '20 calls/hari'],
      ['Bulan 3+', 'Meetings Set', 'Min. 3/minggu'],
      ['Bulan 3+', 'Leads Qualified', '5 leads/minggu · 20+/bulan'],
    ],
  },
]

const OBJECTIONS = [
  { q: '"Saya lagi sibuk."', a: 'Oh oke, saya nggak mau ganggu lama. Boleh saya hubungi lagi besok atau hari [tertentu] di waktu yang lebih enak?' },
  { q: '"Kami udah punya vendor."', a: 'Wah, bagus! Boleh tau pakai siapa sekarang? Saya nggak mau duplikasi — tapi mungkin ada area yang belum ter-cover yang bisa kita bantu.' },
  { q: '"Nggak ada budget."', a: 'Saya ngerti. Banyak perusahaan mulai dari situasi sama. Mau kita diskusi dulu soal potensial value-nya? Kalau nggak cocok, nggak masalah.' },
  { q: '"Kirim email dulu aja."', a: 'Siap! Boleh minta email Bapak/Ibu? Saya kirim overview-nya dan follow up 2–3 hari lagi biar nggak ketenggelam di inbox.' },
  { q: '"Belum ada rencana sekarang."', a: 'Nggak apa-apa! Saya simpan kontak Bapak/Ibu. Boleh saya reach out lagi sekitar 2 bulan ke depan?' },
]

const CRM_STATUS = [
  ['New', 'Kontak baru masuk database, belum dihubungi'],
  ['Contacted', 'Sudah dihubungi tapi belum ada respons berarti'],
  ['Engaged', 'Sudah ngobrol, ada interest, sedang di-nurture'],
  ['Qualified (Opportunity)', 'Sudah 70% BANT — siap handoff ke AM'],
  ['Meeting Scheduled', 'Meeting sudah dijadwalkan dengan AM'],
  ['Not Interested', 'Sudah menyatakan tidak tertarik saat ini'],
  ['Follow Up Later', 'Minta dihubungi kembali di waktu tertentu'],
]

const SECTIONS = [
  { id: 'about', label: 'Tentang ICS', icon: '🏢', desc: 'Profil perusahaan, 6 area solusi, dan partner utama' },
  { id: 'workflow', label: 'Alur Kerja', icon: '🔄', desc: '4 langkah dari prospecting sampai handoff + definisi BANT' },
  { id: 'scripts', label: 'Skrip Telesales', icon: '📞', desc: '6 skrip lengkap per solusi — pilih sesuai target prospect' },
  { id: 'kpi', label: 'KPI & Target', icon: '🎯', desc: 'Target harian, mingguan, bulanan per agent' },
  { id: 'crm', label: 'Standar CRM', icon: '🗂️', desc: 'Yang wajib di-log tiap call + status lead' },
  { id: 'objection', label: 'Objection Handling', icon: '💬', desc: 'Cara handle 5 keberatan paling umum' },
]

// ─── UI helpers ──────────────────────────────────────────────────────────────

function H({ children }) {
  return <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, color: '#111' }}>{children}</div>
}
function Sub({ children }) {
  return <div style={{ fontSize: 13, fontWeight: 600, color: '#444', margin: '14px 0 6px' }}>{children}</div>
}

// ─── Main ─────────────────────────────────────────────────────────────────────

// Kartu menu yang bisa diklik (dipakai di landing & daftar skrip)
function MenuCard({ icon, title, desc, onClick }) {
  return (
    <button onClick={onClick}
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 12, textAlign: 'left', width: '100%',
        background: '#fff', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: '16px',
        cursor: 'pointer', transition: 'box-shadow .15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#185FA5' }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'rgba(0,0,0,0.1)' }}>
      <span style={{ fontSize: 26, lineHeight: 1 }}>{icon}</span>
      <span>
        <span style={{ display: 'block', fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 3 }}>{title}</span>
        <span style={{ display: 'block', fontSize: 12, color: '#777', lineHeight: 1.5 }}>{desc}</span>
      </span>
      <span style={{ marginLeft: 'auto', color: '#bbb', fontSize: 18 }}>›</span>
    </button>
  )
}

// Header dengan tombol back + breadcrumb
function BackBar({ trail, onBack }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' }}>
      <button onClick={onBack}
        style={{ display: 'flex', alignItems: 'center', gap: 5, background: '#fff', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#185FA5' }}>
        ‹ Kembali
      </button>
      <div style={{ fontSize: 12, color: '#888' }}>
        {trail.map((t, i) => (
          <span key={i}>{i > 0 && <span style={{ margin: '0 6px', color: '#ccc' }}>/</span>}{t}</span>
        ))}
      </div>
    </div>
  )
}

// ─── Section content renderers ─────────────────────────────────────────────

function AboutSection() {
  return (
    <Card>
      <H>Tentang ICS Compute</H>
      <p style={{ fontSize: 13, lineHeight: 1.6, color: '#333' }}>
        ICS Compute adalah perusahaan teknologi yang fokus di <strong>Cloud & ISV Solutions</strong>. Kita bantu perusahaan di Indonesia modernisasi infrastruktur IT — dari migrasi cloud, data analytics, monitoring aplikasi, sampai keamanan siber.
      </p>
      <p style={{ fontSize: 13, lineHeight: 1.6, color: '#666', marginTop: 8 }}>
        Kalau ada perusahaan yang masih pakai server on-premise lemot, data berantakan, atau keamanan belum mumpuni — itu target kita.
      </p>
      <Sub>6 Area Solusi Utama</Sub>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {SOLUTIONS.map(s => (
          <div key={s.name} style={{ background: '#f9f9f7', borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{s.icon} {s.name}</div>
            <div style={{ fontSize: 11, color: '#666', lineHeight: 1.5 }}>{s.desc}</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 12, color: '#666', marginTop: 14, background: '#EAF2FB', borderRadius: 8, padding: '10px 12px' }}>
        <strong>Partner utama:</strong> AWS · Databricks · MongoDB · Datadog · Truewatch · Fortinet · Trendmicro · CrowdStrike · Odoo · GitLab
      </div>
    </Card>
  )
}

function WorkflowSection() {
  return (
    <Card>
      <H>Alur Kerja Telesales</H>
      <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>Alur standar dari prospecting sampai deal handoff. Setiap agent wajib jalankan ini setiap hari.</p>
      {WORKFLOW.map(w => (
        <div key={w.step} style={{ display: 'flex', gap: 12, padding: '10px 0', borderBottom: '0.5px solid rgba(0,0,0,0.08)' }}>
          <div style={{ minWidth: 36, height: 36, borderRadius: 8, background: '#185FA5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>{w.step}</div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600 }}>{w.act}</div>
            <div style={{ fontSize: 12, color: '#666', lineHeight: 1.5, marginTop: 2 }}>{w.out}</div>
          </div>
        </div>
      ))}
      <div style={{ fontSize: 12, color: '#333', marginTop: 14, background: '#FEF3E2', borderRadius: 8, padding: '10px 12px', lineHeight: 1.6 }}>
        <strong>📌 Definisi BANT</strong><br />
        <strong>Budget:</strong> Ada anggaran? · <strong>Authority:</strong> Ngobrol sama pengambil keputusan? · <strong>Need:</strong> Butuh solusi kita? · <strong>Timeline:</strong> Kapan mau gerak?<br />
        Minimal 3 dari 4 terpenuhi = Qualified Opportunity.
      </div>
    </Card>
  )
}

function ScriptDetail({ sc }) {
  const [openStep, setOpenStep] = useState(0)
  return (
    <Card>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <span style={{ fontSize: 26 }}>{sc.icon}</span>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>{sc.title}</div>
          <div style={{ fontSize: 11, color: '#888' }}>Partner: {sc.partner}</div>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 12 }}>
        <div style={{ background: '#EAF2FB', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: '#185FA5', marginBottom: 3 }}>🎯 TARGET</div>
          <div style={{ fontSize: 11, color: '#333', lineHeight: 1.4 }}>{sc.target}</div>
        </div>
        <div style={{ background: '#FCEBEB', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: '#A32D2D', marginBottom: 3 }}>😣 PAIN POINT</div>
          <div style={{ fontSize: 11, color: '#333', lineHeight: 1.4 }}>{sc.pain}</div>
        </div>
        <div style={{ background: '#E1F5EE', borderRadius: 8, padding: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: '#0F6E56', marginBottom: 3 }}>💡 SOLUSI</div>
          <div style={{ fontSize: 11, color: '#333', lineHeight: 1.4 }}>{sc.solution}</div>
        </div>
      </div>
      {sc.howto && (
        <div style={{ fontSize: 11, color: '#555', background: '#FEF3E2', borderRadius: 8, padding: '8px 10px', marginBottom: 14, lineHeight: 1.5 }}>
          💡 {sc.howto}
        </div>
      )}

      {/* Langkah — accordion */}
      {sc.steps.map((st, i) => {
        const open = openStep === i
        return (
          <div key={i} style={{ border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
            <button onClick={() => setOpenStep(open ? -1 : i)}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: open ? '#EAF2FB' : '#fff', border: 'none', cursor: 'pointer', textAlign: 'left', padding: '10px 12px' }}>
              <span style={{ minWidth: 22, height: 22, borderRadius: '50%', background: '#185FA5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>{i + 1}</span>
              <span style={{ flex: 1, fontSize: 13, fontWeight: 700, color: '#111' }}>{st.title}</span>
              <span style={{ fontSize: 16, color: '#888' }}>{open ? '−' : '+'}</span>
            </button>

            {open && (
              <div style={{ padding: '10px 12px 14px' }}>
                {st.goal && <div style={{ fontSize: 11, color: '#888', fontStyle: 'italic', marginBottom: 10 }}>🎯 {st.goal}</div>}

                {/* Kalimat agen */}
                {st.agentLines.map((ln, j) => (
                  <div key={j} style={{ fontSize: 12, color: '#333', lineHeight: 1.55, background: '#f9f9f7', borderLeft: '3px solid #185FA5', borderRadius: 6, padding: '8px 10px', marginBottom: 6 }}>
                    <span style={{ display: 'block', fontSize: 9, fontWeight: 700, color: '#185FA5', marginBottom: 3 }}>TELESALES</span>
                    {ln}
                  </div>
                ))}

                {/* Cabang percakapan */}
                {st.branches.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#4A4499', marginBottom: 6 }}>🔀 Cabang Percakapan</div>
                    {st.branches.map((b, j) => (
                      <div key={j} style={{ background: '#EEEDF9', borderRadius: 6, padding: '8px 10px', marginBottom: 5 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#4A4499', marginBottom: 2 }}>↳ {b.cond}</div>
                        <div style={{ fontSize: 11, color: '#333', lineHeight: 1.5 }}>{b.guide}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Contoh eksekusi */}
                {(st.examples.good || st.examples.bad) && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 }}>
                    {st.examples.good && (
                      <div style={{ background: '#E1F5EE', borderRadius: 6, padding: '8px 10px' }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: '#0F6E56', marginBottom: 3 }}>✅ BAGUS</div>
                        <div style={{ fontSize: 11, color: '#333', lineHeight: 1.45 }}>{st.examples.good}</div>
                      </div>
                    )}
                    {st.examples.bad && (
                      <div style={{ background: '#FCEBEB', borderRadius: 6, padding: '8px 10px' }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: '#A32D2D', marginBottom: 3 }}>❌ HINDARI</div>
                        <div style={{ fontSize: 11, color: '#333', lineHeight: 1.45 }}>{st.examples.bad}</div>
                      </div>
                    )}
                  </div>
                )}

                {/* Objection handling (biasanya di langkah closing) */}
                {st.objections.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#A32D2D', marginBottom: 6 }}>🛡️ Objection Handling</div>
                    {st.objections.map((o, j) => (
                      <div key={j} style={{ marginBottom: 6 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#A32D2D', marginBottom: 2 }}>🗣️ "{o.q}"</div>
                        <div style={{ fontSize: 11, color: '#333', lineHeight: 1.5, background: '#f9f9f7', borderLeft: '3px solid #1D9E75', borderRadius: 6, padding: '7px 10px' }}>{o.a}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Tip */}
                {st.tip && (
                  <div style={{ fontSize: 11, color: '#555', background: '#FEF3E2', borderRadius: 6, padding: '8px 10px', marginTop: 10, lineHeight: 1.5 }}>
                    📌 {st.tip}
                  </div>
                )}
              </div>
            )}
          </div>
        )
      })}
    </Card>
  )
}

function KpiSection() {
  return (
    <div>
      <Card>
        <H>KPI & Target</H>
        <p style={{ fontSize: 13, color: '#666' }}>Semua KPI di bawah adalah target minimum. Kalau bisa lebih — bagus! Tapi jangan pernah di bawah ini tanpa alasan valid.</p>
      </Card>
      {KPI_TABLES.map(kt => (
        <div key={kt.title} style={{ marginTop: 10 }}>
          <Card>
            <Sub>{kt.title}</Sub>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                    <th style={{ textAlign: 'left', padding: '6px 8px', color: '#888', fontWeight: 600 }}>Periode</th>
                    <th style={{ textAlign: 'left', padding: '6px 8px', color: '#888', fontWeight: 600 }}>Metric</th>
                    <th style={{ textAlign: 'left', padding: '6px 8px', color: '#888', fontWeight: 600 }}>Target</th>
                  </tr>
                </thead>
                <tbody>
                  {kt.rows.map((r, i) => (
                    <tr key={i} style={{ borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
                      <td style={{ padding: '6px 8px', color: '#888', whiteSpace: 'nowrap' }}>{r[0]}</td>
                      <td style={{ padding: '6px 8px' }}>{r[1]}</td>
                      <td style={{ padding: '6px 8px', fontWeight: 600 }}>{r[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      ))}
    </div>
  )
}

function CrmSection() {
  return (
    <Card>
      <H>Standar CRM & Dokumentasi</H>
      <p style={{ fontSize: 13, color: '#666' }}>CRM yang rapi = data yang bisa dipercaya = pipeline yang bisa di-track dengan benar. Ini bukan opsional.</p>
      <Sub>Yang Wajib Di-log Setiap Call</Sub>
      <ul style={{ fontSize: 12, color: '#333', lineHeight: 1.8, paddingLeft: 18, margin: 0 }}>
        <li>Nama dan jabatan orang yang dihubungi</li>
        <li>Tanggal dan waktu call</li>
        <li>Outcome: Connected / Voicemail / Tidak Diangkat / Nggak Berminat / Follow Up / Qualified</li>
        <li>Pain point yang disebutkan (kalau ada)</li>
        <li>Next action: kapan follow up, meeting dijadwalkan, atau info yang dijanjikan</li>
        <li>BANT score: sudah berapa poin yang terpenuhi</li>
      </ul>
      <div style={{ fontSize: 12, color: '#A32D2D', marginTop: 12, background: '#FCEBEB', borderRadius: 8, padding: '10px 12px', lineHeight: 1.6 }}>
        <strong>🔴 Non-Negotiable</strong><br />
        Jangan pernah tutup hari tanpa update CRM. Kalau kamu nggak log, seolah-olah kamu nggak pernah call.
      </div>
      <Sub>Status Lead di CRM</Sub>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <tbody>
          {CRM_STATUS.map((s, i) => (
            <tr key={i} style={{ borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
              <td style={{ padding: '6px 8px', fontWeight: 600, whiteSpace: 'nowrap' }}>{s[0]}</td>
              <td style={{ padding: '6px 8px', color: '#666' }}>{s[1]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  )
}

function ObjectionSection() {
  return (
    <Card>
      <H>Objection Handling</H>
      <p style={{ fontSize: 13, color: '#666', marginBottom: 6 }}>Tolakan pertama itu normal — sering butuh 3–5 kali kontak sebelum mereka mau dengerin. Ini cara handle keberatan paling umum.</p>
      {OBJECTIONS.map((o, i) => (
        <div key={i} style={{ marginBottom: 10, borderBottom: '0.5px solid rgba(0,0,0,0.06)', paddingBottom: 10 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#A32D2D', marginBottom: 4 }}>{o.q}</div>
          <div style={{ fontSize: 12, color: '#333', lineHeight: 1.55, background: '#f9f9f7', borderLeft: '3px solid #1D9E75', borderRadius: 6, padding: '8px 10px' }}>{o.a}</div>
        </div>
      ))}
    </Card>
  )
}

// ─── Main (drill-down navigation) ──────────────────────────────────────────

export default function Playbook() {
  const [section, setSection] = useState(null)   // null = home
  const [scriptId, setScriptId] = useState(null) // skrip yang dipilih

  const sectionMeta = SECTIONS.find(s => s.id === section)

  // LANDING — menu utama
  if (!section) {
    return (
      <div>
        <div style={{ marginBottom: '1.25rem' }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#111' }}>Telesales Playbook 2026</div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>Panduan resmi tim telesales — pilih menu di bawah untuk mulai.</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {SECTIONS.map(s => (
            <MenuCard key={s.id} icon={s.icon} title={s.label} desc={s.desc}
              onClick={() => { setSection(s.id); setScriptId(null) }} />
          ))}
        </div>
      </div>
    )
  }

  // SCRIPTS — sub-menu pilih skrip, lalu detail
  if (section === 'scripts') {
    if (!scriptId) {
      return (
        <div>
          <BackBar trail={['Playbook', 'Skrip Telesales']} onBack={() => setSection(null)} />
          <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
            Pilih skrip sesuai solusi yang mau kamu tawarkan. Tiap skrip punya flow lengkap dari pembukaan sampai closing.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {SCRIPTS.map(sc => (
              <MenuCard key={sc.id} icon={sc.icon} title={sc.title} desc={`Partner: ${sc.partner}`}
                onClick={() => setScriptId(sc.id)} />
            ))}
          </div>
        </div>
      )
    }
    const sc = SCRIPTS.find(s => s.id === scriptId)
    return (
      <div>
        <BackBar trail={['Playbook', 'Skrip Telesales', sc.title]} onBack={() => setScriptId(null)} />
        <ScriptDetail sc={sc} />
      </div>
    )
  }

  // SECTION biasa
  return (
    <div>
      <BackBar trail={['Playbook', sectionMeta?.label]} onBack={() => setSection(null)} />
      {section === 'about' && <AboutSection />}
      {section === 'workflow' && <WorkflowSection />}
      {section === 'kpi' && <KpiSection />}
      {section === 'crm' && <CrmSection />}
      {section === 'objection' && <ObjectionSection />}
    </div>
  )
}
